// src/components/ProductCard.jsx
function ProductCard({ product }) {
  const nutritionData = [
    { name: 'Energy', value: 61.98, unit: 'Kcal', icon: '⚡' },
    { name: 'Carbs', value: 15.49, unit: 'g', icon: '🌾' },
    { name: 'Sugar', value: 15.33, unit: 'g', icon: '🍬' },
    { name: 'Sodium', value: 109.34, unit: 'mg', icon: '🧂' },
  ];

  return (
    <div className="product-card">
      <div className="product-image-container">
        <img src={product.image} alt={product.name} />
      </div>

      <div className="product-name-with-info">
        <h3>{product.name}</h3>
        <div className="nutrition-info-tooltip">
          <i className="fas fa-info-circle"></i>
          <div className="nutrition-tooltip-content">
            <div className="tooltip-header">Nutrition Facts (Per 100ml)</div>
            {nutritionData.map((nutrient, index) => (
              <div key={index} className="tooltip-nutrient">
                <span className="tooltip-icon">{nutrient.icon}</span>
                <span className="tooltip-name">{nutrient.name}:</span>
                <span className="tooltip-value">{nutrient.value} {nutrient.unit}</span>
              </div>
            ))}
            <div className="tooltip-footer">
              <div>⚡ Contains Caffeine</div>
              <div>🍋 7% Lemon Juice</div>
            </div>
          </div>
        </div>
      </div>

      <p>{product.description}</p>
      <span className="product-price">{product.price}</span>
      <a
        href="https://www.instagram.com/torque_it_is?igsh=MWY5azkyYXE2dG81ZA=="
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="contact-btn">Contact Us</button>
      </a>
    </div>
  );
}

export default ProductCard;
